import * as Yup from "yup";
import { lang } from "../Utils/lang";

/**
 * Phone number validation
 */
const phoneNumberModel = Yup.string()
  .required(lang.required)
  .matches(/^\d{10}$/, lang.invalidPhoneNumber);

export const UserDataModel = Yup.object().shape({
  companyName: Yup.string()
    .required(lang.required)
    .matches(/^[a-zA-Z0-9 ]+$/, lang.invalidCompanyName),
  email: Yup.string()
    .required(lang.required)
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      lang.invalidEmail,
    ),
  phoneNumber: phoneNumberModel,
  password: Yup.string().required(lang.required),
  confirmPassword: Yup.string().required(lang.required),
});

export const CompanyDataModel = Yup.object().shape({
  address: Yup.string().required(lang.required),
  cif: Yup.string().required(lang.required),
  iban: Yup.string().required(lang.required),
  bank: Yup.string().required(lang.required),
  nrRegCom: Yup.string().required(lang.required),
});

export const DelegatesModel = Yup.object().shape({
  firstName: Yup.string().required(lang.required),
  lastName: Yup.string().required(lang.required),
  cnp: Yup.string()
    .required(lang.required)
    .matches(
      /^[125678]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{6}$/,
      lang.invalidCNP,
    ),
  series: Yup.string().required(lang.required),
  nr: Yup.string().required(lang.required),
});

export const DocumentsModel = Yup.object().shape({
  nrContract: Yup.string().required(lang.required),
  nrProforma: Yup.string().required(lang.required),
  serieContract: Yup.string().required(lang.required),
  serieProforma: Yup.string().required(lang.required),
});

/**
 * Location data validation
 */
export const LocationModel = Yup.object().shape({
  nume: Yup.string().required(lang.required),
  adresa: Yup.string().required(lang.required),
  judet: Yup.string().required(lang.required),
  telefon: phoneNumberModel,
});
